"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Vimeo = void 0;
var _react = _interopRequireDefault(require("react"));
var Vimeo = exports.Vimeo = function Vimeo() {
  return _react["default"].createElement("svg", {
    width: "36",
    height: "36",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement("path", {
    d: "M36 32.4C36 34.38 34.38 36 32.4 36H3.6C1.62 36 0 34.38 0 32.4V3.6C0 1.62 1.62 0 3.6 0H32.4C34.38 0 36 1.62 36 3.6V32.4Z",
    fill: "#1AB7EA"
  }), _react["default"].createElement("path", {
    d: "M30.3 11.9701C30.18 14.4901 28.41 17.9701 24.99 22.3801C21.45 26.9701 18.45 29.2801 16.02 29.2801C14.49 29.2801 13.23 27.8701 12.18 25.0801C11.49 22.5001 10.77 19.9501 10.08 17.3701C9.30004 14.5801 8.46004 13.1701 7.56004 13.1701C7.38004 13.1701 6.69004 13.5901 5.52004 14.4001L4.29004 12.8101C5.58004 11.6701 6.84004 10.5601 8.10004 9.42006C9.81004 7.95006 11.1 7.17006 11.97 7.08006C13.98 6.90006 15.24 8.28006 15.72 11.2201C16.23 14.4301 16.59 16.4101 16.77 17.1901C17.34 19.8301 18 21.1801 18.69 21.1801C19.23 21.1801 20.04 20.3101 21.15 18.6001C22.23 16.8901 22.83 15.5701 22.89 14.6701C23.04 13.2001 22.47 12.4501 21.15 12.4501C20.52 12.4501 19.89 12.6001 19.23 12.8701C20.52 8.67006 22.95 6.66006 26.55 6.78006C29.19 6.84006 30.45 8.58006 30.3 11.9701Z",
    fill: "white"
  }));
};